import React from "react";
import AddAndEditUser from "../../../components/AddAndEditUser/AddAndEditUser";

function AddUser() {
  return <AddAndEditUser type="add" />;
}

export default AddUser;
